module.exports = __webpack_public_path__ + "media/ubud/green_rocks-8add6b98.jpg";